module.exports = __webpack_public_path__ + "img/serviceActive.788b266c.png";